import(/* webpackMode: "eager" */ "/vercel/path0/app/room-availability/page.tsx");
